var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionJ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9141 51.5195C24.263 51.5195 23.6901 51.474 23.1953 51.3828C22.7005 51.2917 22.2773 51.168 21.9258 51.0117V48.1797C22.3424 48.3099 22.7917 48.4076 23.2734 48.4727C23.7552 48.5508 24.276 48.5898 24.8359 48.5898C25.5651 48.5898 26.2357 48.4466 26.8477 48.1602C27.4596 47.8737 27.9479 47.3854 28.3125 46.6953C28.6771 46.0052 28.8594 45.0547 28.8594 43.8438V15.4453H32.1992V43.5898C32.1992 45.3737 31.8997 46.8516 31.3008 48.0234C30.7148 49.1953 29.875 50.0677 28.7812 50.6406C27.7005 51.2266 26.4115 51.5195 24.9141 51.5195Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionJ);
export default __webpack_public_path__ + "static/media/section-j.a150d9633d496ef2889455ac75e36dff.svg";
export { ForwardRef as ReactComponent };